var _defineProperty = require("/Users/rjillhammanuel/Documents/Projects/innovotek/hubchart-v4/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/defineProperty");

function _createForOfIteratorHelper(o, allowArrayLike) { var it; if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e2) { throw _e2; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = o[Symbol.iterator](); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e3) { didErr = true; err = _e3; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

require("core-js/modules/es7.symbol.async-iterator");

require("core-js/modules/es6.symbol");

require("core-js/modules/web.dom.iterable");

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest();
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance");
}

function _iterableToArrayLimit(arr, i) {
  var _arr = [];
  var _n = true;
  var _d = false;
  var _e = undefined;

  try {
    for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

var storage = window.localStorage;

exports.storage = function () {
  return storage;
};
/**
 *
 * @param {string} key - data key
 * @param {*} value - data value
 *
 */


exports.setItem = function (key, value, encoded) {
  try {
    var d = encoded ? exports.encode(value) : JSON.stringify(value);
    storage.setItem(key, d);
    return true;
  } catch (error) {
    throw error;
  }
};
/**
 *
 * @param {Object[]} items - collection
 * @param {Object} items[].item - item object
 * @param {string} items[].item.key - data key
 * @param {*} items[].item.value - data value
 *
 */


exports.setMultiple = function (items, encoded) {
  try {
    var _iterator = _createForOfIteratorHelper(items),
        _step;

    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var i = _step.value;
        var d = encoded ? exports.encode(i.value) : JSON.stringify(i.value);
        storage.setItem(i.key, d);
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }

    return true;
  } catch (error) {
    throw error;
  }
};
/**
 *
 * @param {string} key - data key
 * @param {*} value - data value
 *
 */


exports.appendItem = function (key, value) {
  try {
    var data = storage.getItem(key);
    var r = exports.isDataEncoded(data);
    var collection = r[1];
    if (!collection) return; // return as we don't know what format the data should be saved

    var newData = exports.combineObject(value, collection);
    return exports.setItem(key, newData, r[0] === 1);
  } catch (error) {
    throw error;
  }
};
/**
 *
 * @param {Object} object - object to combine
 * @param {Object} toObject - object to combine to
 *
 */


exports.combineObject = function (object, toObject) {
  for (var key in object) {
    toObject[key] = object[key];
  }

  return toObject;
};
/**
 *
 * @param {Object[]} collection - collection of objects
 * @param {Object} object - object to find index from the collection
 * @param {string} attr - attribute of the object to compare to
 *
 */


exports.indexOfObject = function (collection, object, attr) {
  if (!object) return -1;

  for (var i = 0; i < collection.length; i++) {
    if (collection[i][attr] === object[attr]) {
      return i;
    }
  }

  return -1;
};
/**
 *
 * @param {string} parentKey - parent data key
 * @param {string[]} childKeys - data keys - key path
 * @param {string} value - data value
 * @param {string} attrCompare - data attrib compare
 *
 */


exports.updateItemInItem = function (parentKey, childKeys, value, attrCompare) {
  try {
    // map data and update collection
    var mapDataUpdate = function mapDataUpdate(tmpCollection) {
      var newCollection = null;

      var _iterator3 = _createForOfIteratorHelper(childKeys.reverse().entries()),
          _step3;

      try {
        for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
          var _ref3 = _step3.value;

          var _ref4 = _slicedToArray(_ref3, 2);

          var idx = _ref4[0];
          var key = _ref4[1]; // iterate from last key path first

          var _data = tmpCollection[key];

          if (!newCollection) {
            newCollection = _defineProperty({}, key, _data); // set initial value
          } else {
            // update with old data + new data
            newCollection = _defineProperty({}, key, exports.combineObject(newCollection, _data));
          }

          if (idx === childKeys.length - 1) {
            // add modified data to the parent collection
            newCollection = exports.combineObject(newCollection, r[1]); // save and update local

            return exports.setItem(parentKey, newCollection, r[0] === 1);
          }
        }
      } catch (err) {
        _iterator3.e(err);
      } finally {
        _iterator3.f();
      }
    };

    var data = storage.getItem(parentKey);
    var r = exports.isDataEncoded(data);
    var collection = r[1]; // get old collection

    if (!collection) return false; // terminate process

    var tmpCollection = {};
    childKeys = childKeys.map(function (k) {
      return k.trim();
    }); // iterate through with child keys

    var _iterator2 = _createForOfIteratorHelper(childKeys.entries()),
        _step2;

    try {
      for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
        var _ref = _step2.value;

        var _ref2 = _slicedToArray(_ref, 2);

        var idx = _ref2[0];
        var key = _ref2[1];
        if (!collection) return false; // terminate on key not found

        collection = collection[key]; // map data get value from key path

        if (idx === childKeys.length - 1) {
          if (!Array.isArray(collection)) {
            // check if type object
            collection = value; // replace with new value
          } else {
            // collection
            var _idx = attrCompare ? exports.indexOfObject(collection, value, attrCompare) : -1; // append or replace object at index


            if (_idx >= 0) {
              collection[_idx] = value;
            } else {
              collection.push(value);
            }
          } // add to temp collection


          tmpCollection[key] = collection;
          mapDataUpdate(tmpCollection);
        } else {
          // add to temp collection
          tmpCollection[key] = collection;
        }
      }
    } catch (err) {
      _iterator2.e(err);
    } finally {
      _iterator2.f();
    }
  } catch (error) {
    throw error;
  }
};
/**
 *
 * @param {string} parentKey - parent data key
 * @param {string[]} childKeys - data keys - key path
 * @param {string} value - data value
 * @param {string} attrCompare - data attrib compare
 *
 */


exports.getItemInItem = function (parentKey, childKeys, value, attrCompare) {
  try {
    var collection = exports.getItem(parentKey);
    if (!collection) return false; // terminate process

    childKeys = childKeys.map(function (k) {
      return k.trim();
    }); // iterate through with child keys

    var _iterator4 = _createForOfIteratorHelper(childKeys.entries()),
        _step4;

    try {
      for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
        var _ref5 = _step4.value;

        var _ref6 = _slicedToArray(_ref5, 2);

        var idx = _ref6[0];
        var key = _ref6[1];
        if (!collection) return false; // terminate on key not found

        collection = collection[key]; // map data get value from key path

        if (idx === childKeys.length - 1) {
          if (!Array.isArray(collection)) {
            // check if type object
            return collection; // return value
          } else {
            // collection
            var _idx2 = attrCompare ? exports.indexOfObject(collection, value, attrCompare) : -1; // return value


            if (_idx2 >= 0) {
              return collection[_idx2];
            }
          }

          return null;
        }
      }
    } catch (err) {
      _iterator4.e(err);
    } finally {
      _iterator4.f();
    }
  } catch (error) {
    throw error;
  }
};
/**
 *
 * @param {string} parentKey - parent data key
 * @param {string[]} childKeys - data keys - key path
 * @param {string} value - data value
 * @param {string} attrCompare - data attrib compare
 *
 */


exports.removeItemInItem = function (parentKey, childKeys, value, attrCompare) {
  try {
    // map data and update collection
    var mapDataUpdate = function mapDataUpdate(tmpCollection) {
      var newCollection = null;

      var _iterator6 = _createForOfIteratorHelper(childKeys.reverse().entries()),
          _step6;

      try {
        for (_iterator6.s(); !(_step6 = _iterator6.n()).done;) {
          var _ref9 = _step6.value;

          var _ref10 = _slicedToArray(_ref9, 2);

          var idx = _ref10[0];
          var key = _ref10[1]; // iterate from last key path first

          var _data2 = tmpCollection[key];

          if (!newCollection) {
            newCollection = _defineProperty({}, key, _data2); // set initial value
          } else {
            // update with old data + new data
            newCollection = _defineProperty({}, key, exports.combineObject(newCollection, _data2));
          }

          if (idx === childKeys.length - 1) {
            // add modified data to the parent collection
            newCollection = exports.combineObject(newCollection, r[1]); // save and update local

            return exports.setItem(parentKey, newCollection, r[0] === 1);
          }
        }
      } catch (err) {
        _iterator6.e(err);
      } finally {
        _iterator6.f();
      }
    };

    var data = storage.getItem(parentKey);
    var r = exports.isDataEncoded(data);
    var collection = r[1];
    if (!collection) return false; // terminate process

    var tmpCollection = {};
    childKeys = childKeys.map(function (k) {
      return k.trim();
    }); // iterate through with child keys

    var _iterator5 = _createForOfIteratorHelper(childKeys.entries()),
        _step5;

    try {
      for (_iterator5.s(); !(_step5 = _iterator5.n()).done;) {
        var _ref7 = _step5.value;

        var _ref8 = _slicedToArray(_ref7, 2);

        var idx = _ref8[0];
        var key = _ref8[1];
        if (!collection) return false; // terminate on key not found

        collection = collection[key]; // map data get value from key path

        if (idx === childKeys.length - 1) {
          if (Array.isArray(collection)) {
            // check if type object
            // collection
            var _idx3 = attrCompare ? exports.indexOfObject(collection, value, attrCompare) : -1; // remove object at index


            if (_idx3 >= 0) {
              delete collection[_idx3];
              c = collection.filter(function (e) {
                return e ? true : false;
              }); // add to temp collection

              tmpCollection[key] = c;
            }
          }

          mapDataUpdate(tmpCollection);
        } else {
          // add to temp collection
          tmpCollection[key] = collection;
        }
      }
    } catch (err) {
      _iterator5.e(err);
    } finally {
      _iterator5.f();
    }
  } catch (error) {
    throw error;
  }
};
/**
 *
 * @param {string} key - key name of your saved data
 *
 */


exports.getItem = function (key) {
  try {
    var data = storage.getItem(key);
    var r = exports.isDataEncoded(data);
    return r[1];
  } catch (error) {
    throw error;
  }
};
/**
 *
 * @param {object} data - data to be validated
 * @return {object[]} - [0] status, [1] data
 *
 */


exports.isDataEncoded = function (data) {
  var d = exports.decode(data);

  if (d) {
    return [1, d];
  } else if (data && data.startsWith('{') && data.endsWith('}')) {
    d = JSON.parse(data);
    return [0, d];
  } else {
    return [-1, null];
  }
};
/**
 *
 * @param {string[]} keys - key names of your saved data
 *
 */


exports.getMultiple = function (keys) {
  try {
    var items = [];

    var _iterator7 = _createForOfIteratorHelper(keys),
        _step7;

    try {
      for (_iterator7.s(); !(_step7 = _iterator7.n()).done;) {
        var key = _step7.value;
        var data = storage.getItem(key);
        var r = exports.isDataEncoded(data);

        if (r[1]) {
          items.push(r[1]);
        }
      }
    } catch (err) {
      _iterator7.e(err);
    } finally {
      _iterator7.f();
    }

    return items;
  } catch (error) {
    throw error;
  }
};
/**
 *
 * @param {string} key - key name of your saved data
 *
 */


exports.removeItem = function (key) {
  try {
    storage.removeItem(key);
    return true;
  } catch (error) {
    throw error;
  }
};
/**
 *
 * @param {string[]} keys - key names of your saved data
 *
 */


exports.removeMultiple = function (keys) {
  try {
    var _iterator8 = _createForOfIteratorHelper(keys),
        _step8;

    try {
      for (_iterator8.s(); !(_step8 = _iterator8.n()).done;) {
        var key = _step8.value;
        storage.removeItem(key);
      }
    } catch (err) {
      _iterator8.e(err);
    } finally {
      _iterator8.f();
    }

    return true;
  } catch (error) {
    throw error;
  }
};
/**
 *
 * will check if there's saved data under this domain
 * @param {string} key - key names of your saved data
 */


exports.hasData = function (key) {
  try {
    var data = storage.getItem(key);
    return data;
  } catch (error) {
    throw error;
  }
};
/**
 *
 * will purge all saved data under this domain
 *
 */


exports.purge = function () {
  try {
    storage.clear();
    return true;
  } catch (error) {
    throw error;
  }
};
/**
 *
 * @param {Object} obj - object to be encoded
 *
 */


exports.encode = function (obj) {
  var rawStr = JSON.stringify(obj);
  var encodeURI = encodeURIComponent(rawStr);
  var unescapedURI = unescape(encodeURI);
  var encObj = window.btoa(unescapedURI); // console.log('encoded: ', encObj);

  return encObj;
};
/**
 *
 * @param {Object} encObj - object to be decoded
 *
 */


exports.decode = function (encObj) {
  if (!encObj || typeof encObj !== 'string') return null;

  try {
    var decoded = window.atob(encObj);
    var obj = JSON.parse(decoded); // console.log('decoded: ', obj);

    return obj;
  } catch (error) {
    // console.log('decoded error: ', error);
    return null;
  }
};